import FundService from 'src/modules/fund/fundService';
import selectors from 'src/modules/fund/list/fundListSelectors';
import { i18n } from 'src/i18n';
import exporterFields from 'src/modules/fund/list/fundListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';
import Message from 'src/view/shared/message';

const prefix = 'FUND_LIST';

const fundListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,

  FETCH_HOLDINGS_STARTED: `${prefix}_FETCH_HOLDINGS_STARTED`,
  FETCH_HOLDINGS_SUCCESS: `${prefix}_FETCH_HOLDINGS_SUCCESS`,
  FETCH_HOLDINGS_ERROR: `${prefix}_FETCH_HOLDINGS_ERROR`,

  RESETED: `${prefix}_RESETED`,
  SELECTEDS_CHANGED: `${prefix}_SELECTEDS_CHANGED`,

  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,

  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doChangeSelected(payload) {
    return {
      type: fundListActions.SELECTEDS_CHANGED,
      payload,
    };
  },

  doReset: () => async (dispatch) => {
    dispatch({
      type: fundListActions.RESETED,
    });

    dispatch(fundListActions.doFetch());
  },

  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) {
        throw new Error('exporterFields is required');
      }

      dispatch({
        type: fundListActions.EXPORT_STARTED,
      });

      const filter = selectors.selectFilter(getState());
      const response = await FundService.list(
        filter,
        selectors.selectOrderBy(getState()),
        null,
        null,
      );

      new Exporter(
        exporterFields,
        i18n('entities.fund.exporterFileName'),
      ).transformAndExportAsExcelFile(response.rows);

      dispatch({
        type: fundListActions.EXPORT_SUCCESS,
      });

      Message.success(
        i18n('common.exported.success'),
      );
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundListActions.EXPORT_ERROR,
      });
    }
  },

  doChangePaginationAndSort: (pagination, sorter) => async (
    dispatch,
    getState,
  ) => {
    dispatch({
      type: fundListActions.PAGINATION_CHANGED,
      payload: pagination,
    });

    dispatch({
      type: fundListActions.SORTER_CHANGED,
      payload: sorter,
    });

    dispatch(fundListActions.doFetchCurrentFilter());
  },

  doFetchCurrentFilter: () => async (
    dispatch,
    getState,
  ) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(fundListActions.doFetch(filter, rawFilter, true));
  },

  doFetch: (filter?, rawFilter?, keepPagination = false) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: fundListActions.FETCH_STARTED,
        payload: { filter, rawFilter, keepPagination },
      });

      const response = await FundService.list(
        filter,
        selectors.selectOrderBy(getState()),
        selectors.selectLimit(getState()),
        selectors.selectOffset(getState()),
      );

      dispatch({
        type: fundListActions.FETCH_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundListActions.FETCH_ERROR,
      });
    }
  },

  doFetchHoldings: (heldCompany) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: fundListActions.FETCH_HOLDINGS_STARTED,
        payload: { heldCompany },
      });

      const response = await FundService.listHoldings(heldCompany);

      dispatch({
        type: fundListActions.FETCH_HOLDINGS_SUCCESS,
        payload: {
          rows: response.rows,
          count: response.count,
        },
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: fundListActions.FETCH_HOLDINGS_ERROR,
      });
    }
  },
};

export default fundListActions;
